/**
 * @author Ivan Torres
 */
var isPercent = /[0-9]+(?:\.[0-9]+)?%/;
var BROWSER_DEFAULT_FONT_SIZE = '16px';
/**
 * Translates length from pixels to rems units (based on theme `htmlFontSize`)
 */
export default (function (_a, pixels) {
    var theme = _a.theme;
    var htmlFontSize = (theme === null || theme === void 0 ? void 0 : theme.htmlFontSize) || BROWSER_DEFAULT_FONT_SIZE;
    var fontPixels = isPercent.test(htmlFontSize) ? "".concat((parseFloat(htmlFontSize) / 100) * 16, "px") : htmlFontSize;
    return "".concat((typeof pixels === 'string' ? parseInt(pixels, 10) : pixels) / parseInt(fontPixels, 10), "rem");
});
